import { Customer, Account, Coupon, CouponApplication } from '../types'

function multiCoupon(discountPercent: number): Coupon {
  return <Coupon>{
    externalName: discountPercent === 10 ? 'Multiple subscriptions, 10% off (every month)' : `Key account discount, ${discountPercent}% off (every month)`,
    duration: 'forever',
    discountType: 'percent',
    discountPercent: discountPercent
  }
}

function availableCouponApplications(customer: Customer, account: Account): CouponApplication[] {
  const cas = (customer.couponApplications || []).filter(ca => ca.usable)
  const current = customer.subscription && ['active', 'canceled'].includes(customer.subscription.state)
  const useMulti = current ? account.qualifiesForMultiDiscount : account.willQualifyForMultiDiscount
  if (!current && useMulti && !cas.find(ca => ca.coupon.couponCode.startsWith('multi'))) {
    cas.push({
      coupon: multiCoupon(account.multiDiscountPercent),
      id: 0,
      usable: true,
      expired: false,
      future: false
    })
  }
  return cas
}

type DiscountCentsCoupon = Pick<Coupon, 'discountType' | 'discountInCents' | 'discountPercent'>
function discountedCents(cents: number, coupons: DiscountCentsCoupon[]): number {
  let newCents = cents
  coupons.filter(c => c.discountType === 'cents').forEach(c => {
    newCents -= c.discountInCents
  })
  coupons.filter(c => c.discountType === 'percent').forEach(c => {
    newCents *= (100 - c.discountPercent) / 100
  })
  return newCents
}

function prettyDollars(price: number): string {
  const roundedPrice = Math.round(price)
  return roundedPrice ? Math.trunc(roundedPrice / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'
}

function prettyCents(price: number): string {
  const roundedPrice = Math.round(price)
  const cents = roundedPrice ? roundedPrice.toString().slice(-2) : '00'
  return cents === '00' ? '' : cents
}

// Turns
//    6495 to '$64.95'
//    6500 to '$65.00'
//    65 to '$0.65'
// If truncateZeroCents is true
//    6500 to '$65'
//    6510 to '$65.10'
//    6501 to '$65.01'
function centsToCurrencyString(cents: number, options: { truncateZeroCents: boolean } = { truncateZeroCents: false }): string {
  if (cents) {
    const price = (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' })
    return (options.truncateZeroCents && price.slice(-2) === '00') ? price.slice(0, -3) : price
  }
}

function paymentIcon(account: { billingType: 'credit_card' | 'paypal', cardType: string }): string {
  if (account.billingType === 'paypal') {
    return 'fab fa-paypal'
  } else {
    switch (account.cardType) {
      case 'visa': return 'fab fa-cc-visa'
      case 'mastercard': return 'fab fa-cc-mastercard'
      case 'american express': return 'fab fa-cc-amex'
      case 'discover': return 'fab fa-cc-discover'
      default: return 'fas fa-credit-card'
    }
  }
}

export { availableCouponApplications, discountedCents, prettyDollars, prettyCents, centsToCurrencyString, paymentIcon }
